import { resolveIdentifier, types } from 'mobx-state-tree';

import OrderShippingOption from '../../OrderShippingOption';
import ShippingSelectionFieldType from '../../../../types/ShippingSelectionFieldType';

const ShippingSelectionField = types.model('ShippingSelectionField', {
  id: types.identifierNumber,
  value: types.optional(types.string, ''),
});

const SelectedShipping = types
  .model('SelectedShipping', {
    module: types.maybeNull(types.safeReference(OrderShippingOption)),
    pickup_point: types.maybeNull(types.string),
    selection_fields: types.optional(types.map(ShippingSelectionField), {}),
  })
  .preProcessSnapshot((snapshot) => {
    // Transform selection_fields from array to Map format if needed; coerce value to string
    if (snapshot && Array.isArray(snapshot.selection_fields)) {
      const selectionFieldsMap = snapshot.selection_fields.reduce(
        (acc, field) => {
          acc[field.id] = {
            id: field.id,
            value: field.value != null ? String(field.value) : '',
          };
          return acc;
        },
        {}
      );
      return {
        ...snapshot,
        selection_fields: selectionFieldsMap,
      };
    }
    // If selection_fields is undefined or null, ensure it's an empty object
    if (
      snapshot &&
      (snapshot.selection_fields === undefined ||
        snapshot.selection_fields === null)
    ) {
      return {
        ...snapshot,
        selection_fields: {},
      };
    }
    return snapshot;
  })
  .actions((self) => {
    return {
      updateSelectedModule({ id, options }) {
        self.module = resolveIdentifier(OrderShippingOption, options, id);
      },
      updateSelectedPickupPoint({ id }) {
        self.pickup_point = id;
      },
      updateSelectionField({ id, value }) {
        const stringValue = value != null ? String(value) : '';
        if (self.selection_fields.has(id)) {
          const field = self.selection_fields.get(id);
          field.value = stringValue;
        } else {
          self.selection_fields.set(
            id,
            ShippingSelectionField.create({ id, value: stringValue })
          );
        }
      },
      ensureSelectionFieldsFromModule(module) {
        if (
          !module ||
          !module.selection_fields ||
          module.selection_fields.length === 0
        ) {
          return;
        }
        module.selection_fields.forEach((fieldDef) => {
          if (self.selection_fields.has(fieldDef.id)) {
            return;
          }
          let defaultValue =
            fieldDef.value ??
            fieldDef.default_text ??
            (fieldDef.type === ShippingSelectionFieldType.SELECT &&
            fieldDef.options?.[0] != null
              ? fieldDef.options[0].value
              : null) ??
            '';
          self.updateSelectionField({
            id: fieldDef.id,
            value: String(defaultValue),
          });
        });
      },
    };
  });

export default SelectedShipping;
